import { useMemo, useState } from 'react';

const useCachedSearchCriteria = searchCriteria => {
  // cache searchCriteria objects during flight / lowFare queries.
  // This allows us to use the ApolloClient cache
  // by providing the same object values to the 'variables' parameter of 'useQuery'.
  const [cachedSearchCriteria, setCachedSearchCriteria] = useState({
    [getSearchCriteriaKey(searchCriteria)]: searchCriteria,
  });

  return useMemo(() => {
    const key = getSearchCriteriaKey(searchCriteria);
    const cachedValue = cachedSearchCriteria[key];
    if (cachedValue) {
      return cachedValue;
    }
    setCachedSearchCriteria(prev => ({
      ...prev,
      [key]: searchCriteria,
    }));
    return searchCriteria;
  }, [cachedSearchCriteria, searchCriteria]);
};

const getSearchCriteriaKey = queryVariables => {
  const criteriaName = Object.keys(queryVariables)[0];
  const searchCriteria = queryVariables[criteriaName];
  // Part of the key because it can drive campaign pricing, so results must not collide.
  const utmSource = searchCriteria.utmSource || '';
  if (criteriaName === 'lowFareCalendarSearchCriteria') {
    return (
      searchCriteria.origin +
      searchCriteria.destination +
      searchCriteria.searchStartDate +
      searchCriteria.searchEndDate +
      searchCriteria.fareRuleType +
      searchCriteria.passengerCount +
      utmSource
    );
  }
  return (
    searchCriteria.origin +
    searchCriteria.destination +
    searchCriteria.departDate?.date +
    searchCriteria.returnDate?.date +
    searchCriteria.tripType +
    searchCriteria.adultsCount +
    searchCriteria.childrenCount +
    utmSource
  );
};

export default useCachedSearchCriteria;
